package one.healthium.domain.push

import one.healthium.domain.user.UserRepository
import one.primehealth.app.TargetPlatform
import one.primehealth.app.targetPlatform

class PushTokenInteractor internal constructor(
    private val userRepository: UserRepository,
    private val tokenProvider: PushTokenProvider,
) {

    @Throws(Exception::class)
    suspend fun registerToken(token: String, platform: String) {
        val installationId = tokenProvider.getInstallationId()
        userRepository.savePushToken(token, platform, installationId)
    }

    @Throws(Exception::class)
    suspend fun refreshRegistration() {
        val platform = when (targetPlatform()) {
            TargetPlatform.Android -> "android"
            TargetPlatform.iOS -> "ios"
            TargetPlatform.Web -> return
        }
        val token = tokenProvider.getToken()
        registerToken(token, platform)
    }

    @Throws(Exception::class)
    suspend fun unregisterToken() {
        val token = tokenProvider.getToken()
        userRepository.removePushToken(token)
    }
}
